module.exports = "/img/about-gallery-1.f097a8a8.png";